<template>
  <div class="Appdownload">
    <div class="bigImg">
      <div>
        <img src="../../static/appDownload/code.png" alt="">
        <p>扫码下载</p>
      </div>
    </div>
    <div class="iconBox">
      <div class="ibsBox">
        <div>
          <img src="../../static/appDownload/zx.png" alt="">
          <span>丰富的行情资讯</span>
        </div>
        <div>
          <img src="../../static/appDownload/bj.png" alt="">
          <span>精准的产品报价</span>
        </div>
        <div>
          <img src="../../static/appDownload/jl.png" alt="">
          <span>精彩的广场互动</span>
        </div>
        <div>
          <img src="../../static/appDownload/zys.png" alt="">
          <span>智能止盈止损</span>
        </div>
        <div>
          <img src="../../static/appDownload/hd.png" alt="">
          <span>丰富的新手活动</span>
        </div>
        <div>
          <img src="../../static/appDownload/zc.png" alt="">
          <span>超低点差，免费注册</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Appdownload",
    created(){
      // 传参控制显示顶部和底部
      this.$emit('controlShow', false);
    }
  }
</script>

<style lang="less" scoped>
  .Appdownload{
    width: 100%;
    margin: 0 auto;
    text-align: center;
    .bigImg{
      width: 100%;
      height: 500px;
      background: url('../../static/appDownload/banner.png') no-repeat;
      background-size: cover;
      position: relative;
      div{
        width: 140px;
        height: auto;
        position: absolute;
        right: 450px;
        bottom: 40px;
        img{
          width: 100%;
          height: auto;
        }
        p{
          margin: 0;
          background: #e1251a;
          box-sizing: border-box;
          padding: 10px 0;
          color: #fff;
          margin-top: -4px;
        }
      }
    }
    .iconBox{
      width: 100%;
      height: 760px;
      box-sizing: border-box;
      padding: 80px 20px;
      background: url('../../static/appDownload/gnBanner.png') no-repeat;
      background-size: cover;
      .ibsBox{
        width: 1130px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        align-items: center;
        div{
          width: 31.5%;
          height: 270px;
          background-color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: center;
          margin-bottom: 20px;
          img{
            width: 80px;
            height: 80px;
            margin-bottom: 40px;
          }
          span{
            font-size: 18px;
            font-weight: 600;
            line-height: 40px;
            margin-bottom: 40px;
          }
        }
        div:nth-child(1) img{
          width: 70px;
          height: auto;
        }
        div:nth-child(6) img{
          width: 60px;
        }
        div:hover {
          transition: transform 0.35s ease;
          background-color: #e1251a;
        }
        div:hover span{
          color: #fff;
        }
      }
    }
  }

  /* ---------------- wap端(≤768px) ---------------- */
  @media screen and (max-width: 768px) {
    .Appdownload{
      .bigImg{
        width: 100%;
        height: 0;
        // 750 * 920 的wap专用banner
        padding-top: 122.66%;
        background: url('../../static/index/wapImg/downloadBanner.jpg') no-repeat;
        background-size: 100% 100%;
        div{
          width: 100px;
          right: 50%;
          bottom: 20px;
          transform: translateX(50%);
          p{
            padding: 6px 0;
            font-size: 13px;
          }
        }
      }
      .iconBox{
        height: auto;
        box-sizing: border-box;
        padding: 25px 10px;
        background-size: cover;
        .ibsBox{
          width: 100%;
          justify-content: space-between;
          div{
            width: 48.5%;
            height: 150px;
            margin-bottom: 12px;
            justify-content: center;
            img{
              width: 45px;
              height: 45px;
              margin-bottom: 15px;
            }
            span{
              font-size: 14px;
              line-height: 20px;
              margin-bottom: 0;
              text-align: center;
              padding: 0 5px;
            }
          }
          div:nth-child(1) img{
            width: 40px;
          }
          div:nth-child(6) img{
            width: 35px;
          }
          // wap端没有hover，去掉交互态
          div:hover{
            background-color: #fff;
          }
          div:hover span{
            color: inherit;
          }
        }
      }
    }
  }
</style>